import { Service } from "@roc/feature-app-core";

const url = {
  GET_VALUATION_REVIEW_DATA: '/api/v1/property/internalValuationReview/getInternalValuationReviewByLoanIdAndPropertyId',
  INTERNAL_VALUATION_REVIEW: '/api/v1/property/internalValuationReview',
  UPDATE_PROPERTY_COMPS: "/api/v1/property/propertyComp/updatePropertyComps",
  UPLOAD_PROPERTY_COMP_IMAGE: "/api/v1/property/propertyComp/uploadPropertyImage",
  GET_PROPERTY_COMP_IMAGE: "/api/v1/property/propertyComp/getPropertyImage",
  UPLOAD_SUBJECT_IMAGE: "/api/v1/property/internalValuationReview/uploadSubjectImage",
  GET_SUBJECT_IMAGE: "/api/v1/property/internalValuationReview/getSubjectImage",
  GET_REPORT_IMAGES: "/api/v1/property/internalValuationReview/getReportImages",
  MARK_LOAN_TASKS_AS_ACCEPTED: "/api/v1/property/internalValuationReview/markLoanTasksAsAccepted",
};

export class InternalValuationReviewService extends Service {
  url;
  constructor() {
    super();
    this.url = url;
  }

  getInternalValuationReviewData(loanId: number, propertyId: number, disableGlobalLoading = false) {
    return this.get(this.url.GET_VALUATION_REVIEW_DATA,
      { loanId, propertyId },
      { disableGlobalLoading }
    );
  }

  saveInternalValuationReview(payload, disableGlobalLoading = false) {
    if (!payload.internalValuationReviewId) {
      return this.post(this.url.INTERNAL_VALUATION_REVIEW,
        payload, null, { disableGlobalLoading }
      );
    }

    return this.put(this.url.INTERNAL_VALUATION_REVIEW,
      payload, null, null, { disableGlobalLoading }
    );
  }

  updatePropertyComps(payload, disableGlobalLoading = false) {
    return this.put(this.url.UPDATE_PROPERTY_COMPS,
      payload, null, null, { disableGlobalLoading }
    );
  }

  uploadPropertyCompImage(loanId: number, propertyCompId: number, file: File, disableGlobalLoading = false) {
    const formData = new FormData();
    formData.append("loanId", String(loanId));
    formData.append("propertyCompId", String(propertyCompId));
    formData.append("file", file);
    return this.post(this.url.UPLOAD_PROPERTY_COMP_IMAGE, formData, null, { disableGlobalLoading });
  }

  getPropertyCompImage(propertyCompId: number) {
    return this.get(this.url.GET_PROPERTY_COMP_IMAGE,
      { propertyCompId },
      { responseType: 'blob', disableGlobalLoading: true }
    );
  }

  uploadSubjectImage(loanId: number, propertyId: number, file: File, disableGlobalLoading = false) {
    const formData = new FormData();
    formData.append("loanId", String(loanId));
    formData.append("propertyId", String(propertyId));
    formData.append("file", file);
    return this.post(this.url.UPLOAD_SUBJECT_IMAGE, formData, null, { disableGlobalLoading });
  }

  getSubjectImage(loanId: number, propertyId: number) {
    return this.get(this.url.GET_SUBJECT_IMAGE,
      { loanId, propertyId },
      { responseType: 'blob', disableGlobalLoading: true }
    );
  }

  //the photos of the report as data URIs (the browser can't draw the ones from sites without CORS headers in the PDF)
  getReportImages(loanId: number, propertyId: number) {
    return this.post(this.url.GET_REPORT_IMAGES,
      { loanId, propertyId },
      null,
      { disableGlobalLoading: true }
    );
  }

  markLoanTasksAsAccepted(loanId, propertyId) {
    return this.put(`${this.url.MARK_LOAN_TASKS_AS_ACCEPTED}?loanId=${loanId}&propertyId=${propertyId}`, {});
  }
}